// src/api/forms/[name].js

import { apiFetch } from "../lib/request";

/**
 * fetchForm(name) — Retrieve a form object by its unique name.
 *
 * Example:
 *   const form = await fetchForm("contact");
 *   const form = await fetchForm("post-article");
 */
export async function fetchForm(name) {
  if (!name || typeof name !== "string") {
    throw new Error(`fetchForm: invalid name "${name}"`);
  }

  const safeName = encodeURIComponent(name.trim());
  const raw = await apiFetch(`/forms/${safeName}`, { method: "GET" });

  // Backend may return {form}, {result}, or raw
  const f = raw?.form || raw?.result || raw;

  // Your form objects do NOT contain id — they contain name + fields
  if (!f || !f.name) {
    throw new Error(`Form "${name}" not found or missing name`);
  }

  return {
    name: f.name.trim(),
    label: f.label ?? "",
    title: f.title ?? f.name,
    description: f.description ?? "",
    ownerId: f.ownerId ?? null,
    projectId: f.projectId ?? null,

    // fields: always an array
    fields: Array.isArray(f.fields) ? f.fields : [],

    // if schema object exists, include it
    schema: f.schema ?? null,

    // Keep the raw form for debugging/expansion
    raw: f,
  };
}
